import { Summary, SummaryType, RelevantSource } from '../store/research/types';
import { apiRequest } from './api';

export const getCompanySummaries = async (
  companyId: string,
  types: SummaryType[],
): Promise<{ summaries: Record<string, Summary>; relevantSources: RelevantSource[] }> => {
  const response = await apiRequest<{
    summaries: Record<string, Summary>;
    relevantSources: RelevantSource[];
  }>(`/research/summaries/${companyId}?types=${types.join(',')}`, {
    method: 'GET',
  });
  return response;
};
